import { Pipe, PipeTransform } from '@angular/core';

import { TabelaPreco } from '../tabela-preco';
import { TabelaPrecoSituacao } from '../tabela-preco-situacao';

@Pipe({
    name: 'tabelaPrecoSituacaoFilterPipe',
    pure: false
})
export class TabelaPrecoSituacaoFilterPipe implements PipeTransform {
    transform(entities: TabelaPreco[], situacao: TabelaPrecoSituacao): TabelaPreco[] {
        return entities?.filter(entityFilter => entityFilter.situacao === situacao?.id);
    }
}
